import { createContext, useState } from "react";

export const KeyContext = createContext();

const SearchKeyProvider = ({children}) => {
      const [key,setKey] = useState('')
  return <KeyContext.Provider value={{key,setKey}}>{children}</KeyContext.Provider>;
};

export default SearchKeyProvider;
